import axios from 'axios'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken, removeToken } from './auth'

NProgress.configure({ showSpinner: false })

const service = axios.create({
  baseURL: '/api/admin',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截
service.interceptors.request.use(
  config => {
    NProgress.start()
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    NProgress.done()
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    NProgress.done()
    const res = response.data

    // 文件下载等直接返回
    if (response.config.responseType === 'blob') {
      return response
    }

    // 成功
    if (res.code === 200) {
      return res.data
    }

    // 未登录
    if (res.code === 401) {
      Message.error(res.msg || '登录已过期，请重新登录')
      removeToken()
      if (location.hash !== '#/login') {
        location.hash = '#/login'
      }
      return Promise.reject(new Error(res.msg || '未登录'))
    }

    // 无权限
    if (res.code === 403) {
      if (!response.config.silent) Message.error(res.msg || '没有操作权限')
      return Promise.reject(new Error(res.msg || '无权限'))
    }

    // 其他错误
    if (!response.config.silent) Message.error(res.msg || '请求失败')
    return Promise.reject(new Error(res.msg || '请求失败'))
  },
  error => {
    NProgress.done()
    const status = error.response ? error.response.status : 0
    if (status === 401) {
      removeToken()
      location.hash = '#/login'
    }
    if (!error.config || !error.config.silent) {
      Message.error(error.message || '网络异常')
    }
    return Promise.reject(error)
  }
)

export default service
